import React, { Component } from 'react';

export default class Label extends Component {
	static defaultProps = {
		col: 4,
		colLabel: 2,
		label: 'label',
		text: 'text',
	};

	getColums() {
		const { col } = this.props;
		return `form-group col-md-${col}`;
	}

	render() {
		const { label, text } = this.props;
		return (
			<div className={this.getColums()}>
				<b className='mr-1 font-weight-bold'>
					{label}
					:
					{' '}
				</b>
				{text}
			</div>
		);
	}
}
